<script lang="ts" setup>
  import { FolderIcon, OfficesIcon, PositionIcon, UserIcon } from '@/shared/ui/svg'

  import { base as BaseLayout } from '../base'
</script>

<template>
  <BaseLayout>
    <div class="admin-layout pt-5">
      <div class="default-layout__header-menu flex gap-5">
        <RouterLink
          to="/admin/departments"
          class="flex gap-2"
          active-class="border-b-2 border-b-(--grey-light)"
        >
          <FolderIcon />
          <div>{{ $t('admin_breadcrumbs_orgstructure') }}</div>
        </RouterLink>
        <RouterLink
          to="/admin/employees"
          class="flex gap-2"
          active-class="border-b-2 border-b-(--grey-light)"
        >
          <UserIcon
            width="16"
            height="16"
            class="text-(--grey-4)"
          />
          <div>{{ $t('admin_breadcrumbs_employees') }}</div>
        </RouterLink>
        <RouterLink
          to="/admin/positions"
          class="flex gap-2"
          active-class="border-b-2 border-b-(--grey-light)"
        >
          <PositionIcon />
          <div>{{ $t('admin_breadcrumbs_positions') }}</div>
        </RouterLink>
        <RouterLink
          to="/admin/offices"
          class="flex gap-2"
          active-class="border-b-2 border-b-(--grey-light)"
        >
          <OfficesIcon />
          <div>{{ $t('admin_breadcrumbs_offices') }}</div>
        </RouterLink>
        <RouterLink
          to="/admin/countries"
          class="flex gap-2"
          active-class="border-b-2 border-b-(--grey-light)"
        >
          <OfficesIcon />
          <div>{{ $t('admin_breadcrumbs_countries') }}</div>
        </RouterLink>
        <RouterLink
          to="/admin/cities"
          class="flex gap-2"
          active-class="border-b-2 border-b-(--grey-light)"
        >
          <OfficesIcon />
          <div>{{ $t('admin_breadcrumbs_cities') }}</div>
        </RouterLink>
      </div>
      <div class="mt-5">
        <slot />
      </div>
    </div>
  </BaseLayout>
</template>

<style lang="scss">
  .admin-layout {
    .default-layout__header-menu {
      a {
        color: var(--text-primary);
      }
    }

    .content {
      h2 {
        color: var(--text-primary);
      }
    }

    .q-table {
      background-color: var(--background-bg-table) !important;

      th {
        background-color: var(--background-bg-secondary) !important;
        color: var(--text-primary) !important;
        height: 48px;
      }

      td {
        color: var(--text-primary) !important;
      }
    }

    .q-table__bottom {
      background-color: var(--background-bg-secondary) !important;
      color: var(--text-primary) !important;

      .q-btn {
        color: var(--text-primary) !important;

        .q-icon {
          color: var(--text-primary) !important;
        }
      }
    }

    .q-field {
      .q-field__control {
        background-color: var(--background-bg-surface) !important;
        color: var(--text-primary) !important;
      }

      .q-field__native,
      .q-field__input {
        color: var(--text-primary) !important;
        padding-left: 12px !important;
        padding-right: 12px !important;
      }

      .q-field__label {
        color: var(--text-content) !important;
        padding-left: 12px !important;
        padding-right: 12px !important;
      }

      .q-icon {
        color: var(--text-content) !important;
      }

      .q-field__prepend,
      .q-field__append {
        svg {
          color: var(--text-content) !important;
        }
      }

      &.q-field--outlined .q-field__control:before {
        border-color: var(--border-border-primary) !important;
      }

      &.q-field--outlined .q-field__control:hover:before {
        border-color: var(--border-border-primary) !important;
      }

      &.q-field--outlined.q-field--focused .q-field__control:before {
        border-color: var(--border-border-primary) !important;
      }
    }

    .q-menu .q-virtual-scroll__content {
      background-color: var(--background-bg-secondary) !important;

      .q-item {
        color: var(--text-primary) !important;

        &.q-item--active {
          background-color: var(--background-bg-surface) !important;
        }

        &:hover {
          background-color: var(--background-bg-surface) !important;
        }
      }
    }

    .q-date {
      background-color: var(--background-bg-secondary) !important;
      color: var(--text-primary) !important;

      .q-date__header {
        background-color: var(--background-bg-secondary) !important;
        color: var(--text-primary) !important;
      }

      .q-date__navigation,
      .q-date__calendar-weekdays,
      .q-date__calendar-days {
        color: var(--text-primary) !important;
      }

      .q-btn {
        color: var(--text-primary) !important;

        .q-icon {
          color: var(--text-primary) !important;
        }
      }
    }

    .breadcrumbs {
      div {
        color: var(--text-content) !important;
      }

      a {
        color: var(--text-primary) !important;
      }
    }

    .chief-line {
      color: var(--text-content) !important;
    }

    .detail-value {
      color: var(--text-primary) !important;
    }

    .q-toggle__label {
      color: var(--text-primary) !important;
    }
  }
</style>
